import { render, staticRenderFns } from "./CampaignItemPaymentTypeView.vue?vue&type=template&id=2f592218&scoped=true&"
import script from "./CampaignItemPaymentTypeView.vue?vue&type=script&lang=ts&"
export * from "./CampaignItemPaymentTypeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f592218",
  null
  
)

export default component.exports